import { TFunction } from 'i18next'

import { MessageData } from '../models'

// Return translated message with defaultMessage and params
export const getHardwareTestMessage = (message: MessageData, t: TFunction): string =>
  t(message?.key ?? '', { defaultValue: message?.alternativeText, ...message?.params })
